module.exports = __webpack_public_path__ + "resources/img/img_intermax_1.6202d0e644add167bdf97035114c3bc6.png";